import { portalUrl } from "../data";

export default function Structures() {
  return (
    <section id="estruturas" className="sec">
      <div className="wrap">
        <h2 className="h2 sec-title" data-reveal>
          Duas estruturas, um atendimento
        </h2>
        <div className="structures">
          <article className="structure structure-dark" data-reveal>
            <div className="structure-text">
              <h3>FinTrust Securitizadora</h3>
              <p>Antecipação de recebíveis e capital de giro, desde 2019.</p>
              <div className="structure-actions">
                <a href="#contato" className="btn btn-on-dark">
                  Fale com a gente
                </a>
                <a href={portalUrl} className="btn btn-ghost-dark">
                  Portal de clientes
                </a>
              </div>
            </div>
            <div className="structure-media">
              <img
                className="media"
                src="/images/found/curitiba-skyline-2.jpg"
                alt="Prédios do centro de Curitiba ao fim da tarde"
                width="1920"
                height="1206"
                loading="lazy"
                decoding="async"
              />
            </div>
          </article>

          <article className="structure structure-light" data-reveal>
            <div className="structure-text">
              <h3>FinTrust FIDC</h3>
              <p>Fundo de investimento em direitos creditórios, desde julho de 2024.</p>
              <div className="structure-actions">
                <a href="#contato" className="btn">
                  Fale com a gente
                </a>
                <a href={portalUrl} className="btn btn-light">
                  Portal de cedentes
                </a>
              </div>
            </div>
            <div className="structure-media">
              <img
                className="media"
                src="/images/found/curitiba-largo-da-ordem.jpg"
                alt="Igreja da Ordem e casarões no Largo da Ordem, centro histórico de Curitiba"
                width="2336"
                height="1100"
                loading="lazy"
                decoding="async"
              />
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
